import { useState, useEffect } from 'react';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'ABOUT US', subLabel: '私たちについて', href: '#about' },
    { label: 'SERVICE', subLabel: '提供サービス', href: '#services' },
    { label: 'SELECTED WORKS', subLabel: '実績', href: '#portfolio' },
    { label: 'MISSION', subLabel: '使命', href: '#mission' },
    { label: 'CONTACT', subLabel: 'お問い合わせ', href: '#contact' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled ? 'backdrop-blur-sm shadow-sm' : 'bg-transparent'
    }`} style={isScrolled ? { backgroundColor: 'rgba(250, 247, 242, 0.95)' } : {}}>
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center justify-between h-24 relative">
          {/* ロゴ */}
          <a href="/" className="flex items-center space-x-3 cursor-pointer group md:static mt-8 md:mt-0" >
            <div className="w-10 h-10 md:w-10 md:h-10 flex items-center justify-center border border-black group-hover:bg-black transition-colors duration-300">
              <span className="text-2xl md:text-xl font-light text-black group-hover:text-white transition-colors duration-300">E</span>
            </div>
            <span className={`text-sm md:text-sm tracking-[0.2em] font-light transition-colors duration-300 ${
              isScrolled ? 'text-black' : 'text-black'
            }`}>
              EXHIBITION
            </span>
          </a>

          {/* デスクトップメニュー */}
          <div className="hidden md:flex items-center space-x-12">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="flex flex-col items-center text-black hover:text-gray-600 transition-colors duration-300 cursor-pointer group"
              >
                <span className={`text-xs font-semibold tracking-widest uppercase transition-colors duration-300 ${
                  isScrolled ? 'text-black' : 'text-black'
                } group-hover:text-gray-600`}>
                  {item.label}
                </span>
                <span className="text-[10px] font-light mt-0.5 tracking-wide text-gray-500 group-hover:text-gray-400 transition-colors duration-300">
                  {item.subLabel}
                </span>
              </a>
            ))}
          </div>

          {/* モバイルメニューボタン */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex flex-col items-center justify-center space-y-1.5 cursor-pointer ml-auto"
          >
            <span className={`w-6 h-px transition-all duration-300 ${
              isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''
            } ${isScrolled ? 'bg-black' : 'bg-black'}`}></span>
            <span className={`w-6 h-px transition-all duration-300 ${
              isMobileMenuOpen ? 'opacity-0' : 'opacity-100'
            } ${isScrolled ? 'bg-black' : 'bg-black'}`}></span>
            <span className={`w-6 h-px transition-all duration-300 ${
              isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
            } ${isScrolled ? 'bg-black' : 'bg-black'}`}></span>
          </button>
        </div>
      </div>

      {/* モバイルメニュー */}
      <div className={`md:hidden fixed inset-0 z-40 transition-transform duration-500 ${
        isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
      }`} style={{ backgroundColor: '#FAF7F2' }}>
        {/* 閉じるボタン */}
        <button
          onClick={() => setIsMobileMenuOpen(false)}
          className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-black hover:opacity-50 transition-opacity cursor-pointer"
        >
          <i className="ri-close-line text-2xl"></i>
        </button>

        <div className="flex flex-col items-center justify-center h-full space-y-12">
          {navItems.map((item, index) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex flex-col items-center text-black hover:text-gray-600 transition-colors duration-300 cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <span className="text-xl font-semibold tracking-widest uppercase">{item.label}</span>
              <span className="text-xs font-light mt-1 tracking-wide">{item.subLabel}</span>
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
